<template>
  <header class="site-header">
    <div class="header-inner">
      <router-link to="/" class="logo" aria-label="有道开口读"></router-link>
      <nav class="nav">
        <router-link class="nav-item" exact to="/" active-class="is-active">
          首页
        </router-link>
        <span class="nav-item has-arrow has-menu">
          课程产品
          <i class="arrow"></i>
          <span class="dropdown-menu">
            <a
              v-for="item in courseLinks"
              :key="item.name"
              class="dropdown-link"
              :href="item.url"
              target="_blank"
            >
              {{ item.name }}
            </a>
          </span>
        </span>
        <span class="nav-item has-arrow has-menu">
          专项训练
          <i class="arrow"></i>
          <span class="dropdown-menu">
            <a
              v-for="item in trainingLinks"
              :key="item.name"
              class="dropdown-link"
              :href="item.url"
              target="_blank"
            >
              {{ item.name }}
            </a>
          </span>
        </span>
        <router-link class="nav-item" to="/brand-news" active-class="is-active">
          品牌资讯
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  data() {
    return {
      courseLinks: [
        {
          name: '14天英语拼读直播',
          url: 'https://c.youdao.com/market/phonics.html'
        },
        {
          name: '全外教英语启蒙 AI 课',
          url: 'https://kids.youdao.com/wx/index.html#/landing?sign=zLY3XhwzhY&outVender=guanwang'
        },
        {
          name: '全外教自拼阅读 AI 课',
          url: 'https://kids.youdao.com/wx/index.html#/landing?sign=zLYrvyUWy8&outVender=guanwang'
        },
        {
          name: '牛津话英语综合素养 AI 课',
          url: 'https://kids.youdao.com/wx/index.html#/landing?sign=zXFFXgAvJI&outVender=guanwang'
        }
      ],
      trainingLinks: [
        {
          name: '有道天天读英文分级阅读',
          url: 'https://kids.youdao.com/wx/index.html#/landing?sign=tFIaxhQPjs&outVender=guanwang'
        },
        {
          name: 'Hi！外教智能口语陪练',
          url: 'https://kids.youdao.com/wx/index.html#/landing?sign=zLYlrNEnfk&outVender=guanwang'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
$color: #666666;
$active-color: #18d2fc;

.site-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background: #ffffff;
}
.header-inner {
  display: flex;
  align-items: center;
  max-width: 1200px;
  box-sizing: border-box;
  height: 64px;
  margin: 0 auto;
  padding: 0 24px;
}
.logo {
  display: block;
  flex-shrink: 0;
  background: url(../assets/img/home/logo.png) left center no-repeat;
  background-size: contain;
  width: 347px;
  height: 32px;
}
.nav {
  display: flex;
  align-items: center;
  margin-left: 155px;
}
.nav-item {
  margin-right: 4px;
  position: relative;
  padding: 0 16px;
  height: 64px;
  line-height: 64px;
  font-size: 16px;
  font-weight: 400;
  color: $color;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  &:last-child {
    margin-right: 0;
  }
}
.has-menu {
  &:hover {
    color: $active-color;

    .arrow {
      border-color: $active-color;
      transform: rotate(225deg) translate(-1px, -1px);
    }

    .dropdown-menu {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(0);
      pointer-events: auto;
    }
  }
}
.dropdown-menu {
  position: absolute;
  top: 64px;
  left: 50%;
  z-index: 10;
  box-sizing: border-box;
  width: 192px;
  padding: 6px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(10, 117, 142, 0.15);
  visibility: hidden;
  transform: translateX(-50%) translateY(8px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
  pointer-events: none;
}
.dropdown-link {
  display: block;
  height: 28px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 14px;
  line-height: 28px;
  color: #666666;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #22283d;
    background: #eefcff;
  }
}
/* chevron 箭头：两根线组成的 V 形 */
.arrow {
  display: inline-block;
  margin-left: 5px;
  width: 6px;
  height: 6px;
  border-right: 1.5px solid $color;
  border-bottom: 1.5px solid $color;
  transform: rotate(45deg) translateY(-2px);
}
/* 选中态：蓝色文字 + 底部小圆点 */
.nav-item.is-active {
  font-size: 18px;
  font-weight: 600;
  color: $active-color;
}
.nav-item.is-active::after {
  content: '';
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: $active-color;
}
</style>
